export default function BrandLogo({
  compact = false,
  className = "",
  imageClassName = "",
  textClassName = "",
  subtitleClassName = "",
}) {
  const logoSrc = `${process.env.PUBLIC_URL || ""}/logo-192.png`;

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <img
        src={logoSrc}
        alt="Oswal Sabha Professional Forum logo"
        className={`shrink-0 object-contain ${compact ? "w-10 h-10" : "w-11 h-11"} ${imageClassName}`}
      />
      {!compact && (
        <div className="leading-tight">
          <div
            className={`font-heading text-base md:text-lg font-semibold tracking-tight text-ink ${textClassName}`}
          >
            Oswal Sabha
          </div>
          <div
            className={`text-[11px] uppercase tracking-[0.22em] text-black ${subtitleClassName}`}
          >
            Professional Forum
          </div>
        </div>
      )}
    </div>
  );
}
